<template>
  <div class="cfo-task-queue-history">
    <div class="history-header">
      <h3 class="history-title">定时任务历史</h3>
      <span class="history-count">共 {{ records.length }} 条记录</span>
    </div>
    <div class="history-list">
      <div
        v-for="(item, index) in records"
        :key="index"
        class="history-card"
      >
        <div class="card-top">
          <div class="card-title-h">{{ item.title }}</div>
          <div class="card-meta">
            <span class="card-agent">{{ item.agent }}</span>
            <span class="status-tag" :class="`status-tag--${item.status}`">{{ item.statusLabel }}</span>
            <span v-if="item.progress" class="card-progress">{{ item.progress }}</span>
            <span class="card-eta">ETA:{{ item.eta }}</span>
          </div>
        </div>
        <div class="card-desc">{{ item.desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
const TASK_QUEUE_HISTORY = [
  {
    title: 'CEO 指令：明确毛利率下降原因',
    agent: '财务数字人',
    status: 'running',
    statusLabel: '运行中',
    progress: '76%',
    eta: '2026-06-25',
    desc: '制定毛利率改善方案，含供应链归因分析与关差动作闭环。'
  },
  {
    title: '采购降本兑现率重算',
    agent: '指标定义智能体',
    status: 'running',
    statusLabel: '运行中',
    progress: '60%',
    eta: '2026-06-26',
    desc: '按60%/80%/100%三档测算采购降本兑现率，更新采购降本预测模型。'
  },
  {
    title: '制造端质量损失责任边界确认',
    agent: '本体治理智能体',
    status: 'pending',
    statusLabel: '待确认',
    eta: '2026-06-27',
    desc: '质量损失、物耗、制造费率需财务和工厂共同确认责任归属与分摊逻辑。'
  },
  {
    title: '月度经营例会材料准备',
    agent: '财务数字人',
    status: 'done',
    statusLabel: '已完成',
    eta: '2026-06-22',
    desc: '汇总6月经营数据、差异分析与改善建议，生成例会报告。'
  }
]

export default {
  name: 'CfoTaskQueueHistory',
  data() {
    return {
      records: TASK_QUEUE_HISTORY
    }
  }
}
</script>

<style lang="scss" scoped>
.cfo-task-queue-history {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 16px 20px;
  overflow: hidden;
  background: #fff;
}

.history-header {
  margin-bottom: 12px;
  flex-shrink: 0;
}

.history-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 4px;
}

.history-count {
  font-size: 11px;
  color: #94a3b8;
}

.history-list {
  flex: 1;
  overflow-y: auto;
  padding-right: 4px;
}

.history-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid #e8ecf0;
  border-radius: 10px;
  background: #fff;
  margin-bottom: 6px;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: rgba(74, 95, 243, 0.3);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.card-body {
  flex: 1;
  min-width: 0;
}

.card-title-h {
  font-size: 12px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 4px;
}

.card-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.card-agent {
  font-size: 11px;
  color: #64748b;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 600;

  &--running {
    background: #eef2ff;
    color: #4A5FF3;
  }

  &--pending {
    background: #fef3c7;
    color: #b45309;
  }

  &--done {
    background: #dcfce7;
    color: #15803d;
  }
}

.card-progress {
  font-size: 11px;
  font-weight: 600;
  color: #4A5FF3;
}

.card-eta {
  font-size: 11px;
  color: #94a3b8;
}

.card-desc {
  font-size: 11px;
  color: #64748b;
  line-height: 1.5;
  text-align: left;
}
</style>
